import React from 'react'
import {MdKeyboardArrowRight} from 'react-icons/md'
import { Link } from 'react-scroll'
import HeroImage from "../assets/HeroImage.jpg"


// import React from 'react'

function Home() {
  return (
    <div name="home" 
    className="h-screen bg-gradient-to-b from-black via-black to-gray-800">
 
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row  ">

           
            {/* heading div */}
            <div className="flex flex-col justify-center h-full">
            <h2 className="text-4xl sm:text-7xl font-bold text-white">
              I'm a Frontend Developer
            </h2>
            <p className="text-gray-500 py-4 max-w-md">
              I have 1 Year of Experience Building and Desinging Software,
              Currently, I Love to work on Web application using Tecnologies like
              React , Tailwind , Bootstarp ,Javascript
            </p>
            {/* Boton div */}
            <div>
              <Link to="portfolio" smooth duration={500}
               className="group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-blue-900 to-blue-200 cursor-pointer">
                 Portfolio
                 <span className="group-hover:rotate-90 duration-300">
                  <MdKeyboardArrowRight size={30} className="ml-1"/>
                 </span>
              </Link>
            </div>

            </div>
                  {/* Hero Image div */}
                  <div>
                    <img src={HeroImage} alt="my profile" 
                    className="rounded-2xl mx-auto w-2/3 md:w-full" />
                    </div>  
      </div>
      </div>
  )
}

export default Home
 
